import { createEnvironmentTasksEntry } from "./utils";

/**
 * How many `environment.task` activities to window for status + last-run.
 * The activities endpoint has no `parameters.task` server filter (gap #4), so
 * we over-fetch and group client-side; a task whose last run falls outside this
 * window degrades to "Never run".
 */
export const TASK_ACTIVITY_WINDOW = 100;

/**
 * Stable, frozen default returned by selectors when an environment has no entry
 * yet. Derived from the reducer's factory so the shape can't drift; frozen
 * because selectors only ever read it.
 */
export const EMPTY_ENVIRONMENT_TASKS_ENTRY = Object.freeze(
  createEnvironmentTasksEntry()
);
